import { isArray, isObject } from "lodash";
import React, { useCallback, useEffect } from "react";

// Imported components
import ClusterMarker from "./ClusterMarker";
import Marker from "./Marker";

// Imported hooks
import useSupercluster from "../hooks/useSupercluster";

const superclusterOptions = {
  extent: 256,
  radius: 80,
  maxZoom: 19,
  map: (props) => ({ data: [props.data] }),
  reduce: (accumulated, props) => {
    accumulated.data = accumulated.data.concat(props.data);
  },
};

const ClusteredMarkers = ({
  filteredMarkers,
  onClick,
  selectedStation,
  setSelectedStation,
}) => {
  const { clusters, getLeaves } = useSupercluster(
    filteredMarkers,
    superclusterOptions
  );

  const handleMarkerClick = useCallback((data) => {
    onClick(data);
  }, []);

  return (
    <>
      {clusters.map((feature) => {
        const [lng, lat] = feature.geometry.coordinates;

        const clusterProperties = feature.properties;
        const isCluster = clusterProperties.cluster;

        return isCluster ? (
          <ClusterMarker
            clusterId={clusterProperties.cluster_id}
            data={clusterProperties.data}
            key={feature.id}
            onMarkerClick={handleMarkerClick}
            position={{ lat, lng }}
            selectedStation={selectedStation}
            setSelectedStation={setSelectedStation}
            size={clusterProperties.point_count}
          />
        ) : (
          <Marker
            data={clusterProperties.data}
            featureId={feature.id}
            key={feature.id}
            onMarkerClick={handleMarkerClick}
            position={{ lat, lng }}
            selectedStation={selectedStation}
          />
        );
      })}
    </>
  );
};

export default ClusteredMarkers;
